import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { PropertyOwnerModel } from '../models/propertyOwnerModel';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-ownerdetails',
  templateUrl: './ownerdetails.component.html',
  styleUrls: ['./ownerdetails.component.scss']
})
export class OwnerdetailsComponent implements OnInit {

  constructor(private router : Router, private data: DataService,private _sanitizer: DomSanitizer) { 
    
  }

  public owner: PropertyOwnerModel;
  public imagePath: SafeResourceUrl;

  public GenderText : string;

  ngOnInit(): void {
    this.owner = this.data.SelectedOwner;
    this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' 
    + this.owner.ownerinformation.personimage);

    switch(this.owner.ownerinformation.gender){
      case 1:
      {
        this.GenderText = "Male";
        break;
      }
      case 2: 
      {
        this.GenderText = "Female";
        break;
      }
      case 3: 
      {
        this.GenderText = "Unknown";
        break;
      }
    }
  
  }

  onOwnersDocuments(id : PropertyOwnerModel){
    this.router.navigate(['ownersdocuments'],{skipLocationChange: false});;
  }

}
